import compose from 'ramda/src/compose'
import length from 'ramda/src/length'
import gt from 'ramda/src/gt'
import prop from 'ramda/src/prop'
import __ from 'ramda/src/__'
import slice from 'ramda/src/slice'

export default (value) => {
	const label = prop('label', value)
	const isNeedTriming = compose(gt(__, 9), length)(label)
	if (isNeedTriming) {
		return `${compose(slice(0, 9))(label)}...`
	}
	return label
}
